import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface LockStatus {
  isLocked: boolean;
  expiry: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SystemLockService {
  private apiUrl = `${environment.BASE_URL}api/lock-system.php`;

  constructor(private http: HttpClient) {}

  getLockStatus(): Observable<LockStatus> {
    return this.http.get<LockStatus>(this.apiUrl);
  }

  updateLockStatus(status: number, duration: number = 0,scope): Observable<any> {
    return this.http.put(this.apiUrl, { 
      status: status, 
      duration_minutes: duration,
      scope: scope
    });
  }
}